import React from "react";

const Footer = () => {
  return (
    <footer className="text-center text-white p-4 bg-gray-800">
      <div>
        <p>Copyright © 2023 - All right reserved by Fahim Shariar</p>
      </div>
    </footer>
  );
};

export default Footer;
